import { privateAxios } from "@/common/api/axios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseNegotiationsProps<T> = {
  filters?: {
    page?: number;
    search?: string;
    status?: string;
    client_company_id?: string;
  };
  mapper?: (data: any) => T,
};

export const useNegotiations = <T,>({
  filters: { search, page, status, client_company_id } = {},
  mapper = Mapper.default<T>(),
}: UseNegotiationsProps<T>) => {
  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['negotiations', search, page, status, client_company_id],
    queryFn: () => {
      return privateAxios.get(`/client/negotiations`, {
        params: {
          search,
          page,
          'q[status_eq]': status,
          'q[client_company_id]': client_company_id,
        }
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
    retry: 0,
  });

  return { data, meta, ...rest };
};
